import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { Component } from 'react';
import { PnmacCard, PnmacPageBubble, PnmacParagraph, PnmacRow, PnmacRowHeader, PnmacSectionListView, PnmacSelect, PnmacSubheading, PnmacTable, PnmacTabs, PnmacText, PnmacTextInput, PnmacUIButton, PnmacMediaQuery, PnmacMeta } from "pnmac-universal-components";
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { Image, View } from 'react-native';
import moments from 'moment';
import { currencyFormatter, loanTerm, addMonths, checkForAllNumbers, percentFormatter } from '../utils.js';
import { Line } from '../components/Chart/ChartComponent';
import styles from '../styles/styles.js';
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import Pagination from '@material-ui/lab/Pagination';
import { TextField, Tooltip } from '@material-ui/core';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../redux/events/events.js';
import { textStyle } from "../v2/theme";
import MomentAdapter from "@material-ui/pickers/adapter/moment";
import withPnmacTitle from "../withPnmacTitle";
import { fullBrowserVersion } from 'react-device-detect';
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import pnmacLogo from '../assets/pnmacLogo.png';
var leftContent = function (props, small, cal) {
  return /*#__PURE__*/React.createElement(Image, {
    alt: "",
    style: {
      width: small ? cal ? 26 : 35 : cal ? 60 : 65,
      height: small ? 35 : 75
    },
    source: props
  });
};
var PnmacToolTip = function (_a) {
  var title = _a.title,
    children = _a.children;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: title
  }, children);
};
var AmortizationCalculator = /** @class */function (_super) {
  __extends(AmortizationCalculator, _super);
  function AmortizationCalculator(props) {
    var _this = _super.call(this, props) || this;
    _this.requestAmoritization = function (post) {
      _this.setState({
        loading: true
      });
      fetch('api/amortization/calculate_for_principal_and_interest', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: JSON.stringify(post)
      }).then(function (data) {
        return data.json();
      }).then(function (res) {
        _this.setState({
          amortzationData: res,
          loading: false,
          page: "schedule"
        });
      }).catch(function (err) {
        _this.setState({
          loading: false
        });
      });
      _this.state.goal == "LAC" ? _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Amortizaton Calculator Button Clicked for Loan Amortization Calculator", 0) : _this.state.goal == "CPI" ? _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Amortizaton Calculator Button Clicked for Calculate Principle and Interest", 0) : _this.state.goal == "PSD" ? _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Amortizaton Calculator Button Clicked for Payoff by Specific Date", 0) : _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Amortizaton Calculator Button Clicked for Make Extra Payment", 0);
    };
    _this.getSummaryLineChartData = function (amortzationData) {
      var interest = amortzationData.amortizationSchedule.map(function (s) {
        return {
          y: parseFloat(s.interest),
          x: moments(s.paymentDate).format("YYYY")
        };
      }).filter(function (value, index, self) {
        return self.map(function (s) {
          return s.x;
        }).indexOf(value.x) === index;
      });
      var principal = amortzationData.amortizationSchedule.map(function (s) {
        return {
          y: parseFloat(s.principalTotal),
          x: moments(s.paymentDate).format("YYYY")
        };
      }).filter(function (value, index, self) {
        return self.map(function (s) {
          return s.x;
        }).indexOf(value.x) === index;
      });
      var data = {
        labels: amortzationData.amortizationSchedule.map(function (s) {
          return moments(s.paymentDate).format("YYYY");
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index;
        }),
        datasets: [{
          data: principal,
          label: "principal",
          strokeColor: "rgba(220,220,220,1)",
          pointColor: "rgba(200,122,20,1)",
          backgroundColor: "rgba(86,183,225,.5)"
        }, {
          data: interest,
          label: "interest",
          strokeColor: 'rgba(220,180,0,1)',
          pointColor: 'rgba(220,180,0,1)',
          backgroundColor: "rgba(225,100,93,.5)"
        }]
      };
      return data;
    };
    _this.state = {
      goal: "",
      targetMaturityDate: null,
      amortzationData: null,
      loading: false,
      PayFrequency: null,
      page: "schedule",
      pagination: 1
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  AmortizationCalculator.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var _m = this.props,
      translations = _m.translations,
      layout = _m.layout;
    var _o = this.state,
      amortzationData = _o.amortzationData,
      page = _o.page,
      pagination = _o.pagination,
      goal = _o.goal;
    var tempGoal;
    if (!this.state.goal) {
      tempGoal = "";
    } else {
      tempGoal = this.state.goal;
    }
    var dataExpandable = [{
      title: "".concat(translations.howToUse),
      data: [{
        header: "".concat(translations.howToUse)
      }]
    }, {
      title: "".concat(translations.AmortizationCalculatorMsg),
      data: [{
        header: "".concat(translations.AmortizationCalculatorMsg)
      }]
    }];
    var tableHead = [translations.PaymentPeriodScheduleGrid, translations.DateScheduleGrid, translations.PrincipalScheduleGrid, translations.InterestScheduleGrid, translations.BalanceScheduleGrid];
    var tableData = ((amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.amortizationSchedule) || []).map(function (s) {
      return [s.loanMonth, moments(s.paymentDate).format("MM/DD/YYYY"), currencyFormatter('en-US', 'currency', 'USD', s.principalTotal), currencyFormatter('en-US', 'currency', 'USD', s.interest), currencyFormatter('en-US', 'currency', 'USD', s.remainingLoanBalnce)];
    });
    var convertToPDF = function (tableHead, tableData) {
      return __awaiter(_this, void 0, void 0, function () {
        var pdfDoc, font, boldFont, fontSize, lineHeight, pageWidth, pageHeight, currentPage, logoImage, logoX, logoY, y, padding, tableWidth, drawHorizontalLine, drawVerticalLine, propertyAddress, propertyLocality, propertyRegion, propertyPostalCode, i_1, _loop_1, _i, tableData_1, row, pdfBytes;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
          switch (_f.label) {
            case 0:
              return [4 /*yield*/, PDFDocument.create()];
            case 1:
              pdfDoc = _f.sent();
              return [4 /*yield*/, pdfDoc.embedFont(StandardFonts.Helvetica)];
            case 2:
              font = _f.sent();
              return [4 /*yield*/, pdfDoc.embedFont(StandardFonts.HelveticaBold)];
            case 3:
              boldFont = _f.sent();
              fontSize = 10;
              lineHeight = 20;
              pageWidth = 595;
              pageHeight = 842;
              currentPage = pdfDoc.addPage([pageWidth, pageHeight]);
              return [4 /*yield*/, pdfDoc.embedPng(pnmacLogo)];
            case 4:
              logoImage = _f.sent();
              logoX = 50;
              logoY = pageHeight - 80;
              currentPage.drawImage(logoImage, {
                x: logoX,
                y: logoY,
                width: 100,
                height: 50
              });
              y = logoY - 20;
              padding = 10;
              tableWidth = tableHead.length * 100;
              drawHorizontalLine = function (x, y, width) {
                currentPage.drawLine({
                  start: {
                    x: x,
                    y: y
                  },
                  end: {
                    x: x + width,
                    y: y
                  }
                });
              };
              drawVerticalLine = function (x, y, height) {
                currentPage.drawLine({
                  start: {
                    x: x,
                    y: y
                  },
                  end: {
                    x: x,
                    y: y - height
                  }
                });
              };
              currentPage.drawText("Loan ".concat((_a = layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId), {
                x: 50,
                y: y,
                size: fontSize,
                color: rgb(0, 0, 0)
              });
              y -= lineHeight;
              propertyAddress = ((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.propertyAddressLine1) || "No address provided";
              propertyLocality = ((_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.propertyLocality) || "";
              propertyRegion = ((_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.propertyRegion) || "";
              propertyPostalCode = ((_e = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _e === void 0 ? void 0 : _e.propertyPostalCode) || "";
              currentPage.drawText("".concat(propertyAddress), {
                x: 50,
                y: y,
                size: fontSize,
                font: font,
                color: rgb(0, 0, 0)
              });
              y -= lineHeight;
              currentPage.drawText("".concat(propertyLocality, " ").concat(propertyRegion, ", ").concat(propertyPostalCode), {
                x: 50,
                y: y + lineHeight / 2,
                size: fontSize,
                font: font,
                color: rgb(0, 0, 0)
              });
              y -= lineHeight;
              tableHead.forEach(function (header, index) {
                currentPage.drawText(header, {
                  x: 50 + index * 100 + padding,
                  y: y - padding,
                  size: fontSize,
                  font: boldFont,
                  color: rgb(0, 0, 0)
                });
              });
              y -= lineHeight;
              drawHorizontalLine(50, y + lineHeight, tableWidth);
              for (i_1 = 0; i_1 <= tableHead.length; i_1++) {
                drawVerticalLine(50 + i_1 * 100, y + lineHeight, lineHeight);
              }
              _loop_1 = function (row) {
                if (y - lineHeight < 50) {
                  drawHorizontalLine(50, y, tableWidth);
                  currentPage = pdfDoc.addPage([pageWidth, pageHeight]);
                  y = pageHeight - 50;
                  tableHead.forEach(function (header, index) {
                    currentPage.drawText(header, {
                      x: 50 + index * 100 + padding,
                      y: y - padding,
                      size: fontSize,
                      font: boldFont,
                      color: rgb(0, 0, 0)
                    });
                  });
                  y -= lineHeight;
                  drawHorizontalLine(50, y + lineHeight, tableWidth);
                  for (var i_2 = 0; i_2 <= tableHead.length; i_2++) {
                    drawVerticalLine(50 + i_2 * 100, y + lineHeight, lineHeight);
                  }
                }
                drawHorizontalLine(50, y, tableWidth);
                row.forEach(function (cell, index) {
                  currentPage.drawText(cell.toString(), {
                    x: 50 + index * 100 + padding,
                    y: y - padding,
                    size: fontSize,
                    font: font,
                    color: rgb(0, 0, 0)
                  });
                  if (index < row.length - 1) {
                    drawVerticalLine(50 + (index + 1) * 100, y, lineHeight);
                  }
                });
                y -= lineHeight;
                for (var i_3 = 0; i_3 <= tableHead.length; i_3++) {
                  drawVerticalLine(50 + i_3 * 100, y + lineHeight, lineHeight);
                }
              };
              for (_i = 0, tableData_1 = tableData; _i < tableData_1.length; _i++) {
                row = tableData_1[_i];
                _loop_1(row);
              }
              drawHorizontalLine(50, y, tableWidth);
              return [4 /*yield*/, pdfDoc.save()];
            case 5:
              pdfBytes = _f.sent();
              return [2 /*return*/, pdfBytes];
          }
        });
      });
    };
    var downloadPDF = function (pdfContent, filename) {
      var blob = new Blob([pdfContent], {
        type: 'application/pdf'
      });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('download', filename);
      a.click();
    };
    var handlePDFExport = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var pdfContent;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4 /*yield*/, convertToPDF(tableHead, tableData)];
            case 1:
              pdfContent = _b.sent();
              downloadPDF(pdfContent, "amortization_schedule_".concat((_a = layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId, ".pdf"));
              return [2 /*return*/];
          }
        });
      });
    };
    var i = Math.abs(moments((_b = (_a = this.state.amortzationData) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.termEndDate).format("MM") - moments((_c = layout.currentLoan) === null || _c === void 0 ? void 0 : _c.loanMaturityDate).format("MM") + 12 * (moments((_e = (_d = this.state.amortzationData) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.termEndDate).format("YYYY") - moments((_f = layout.currentLoan) === null || _f === void 0 ? void 0 : _f.loanMaturityDate).format("YYYY")));
    var soonerMonths = i % 12;
    var soonerYears = i / 12;
    var startCurtailment = (_g = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _g === void 0 ? void 0 : _g.nextPaymentDueDate;
    var endCurtailment = moments((_h = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _h === void 0 ? void 0 : _h.loanMaturityDate);
    var months = parseInt(endCurtailment.diff(moments(startCurtailment), 'months', true));
    var sequence = [{
      date: moments(startCurtailment).format("MM/YYYY"),
      curtailment: 1
    }];
    for (var i = 1; i <= months; i++) {
      sequence.push({
        date: moments(startCurtailment).add({
          months: i
        }).format("MM/YYYY"),
        curtailment: i + 1
      });
    }
    var LoanTermMonths = 0;
    if (this.state.targetMaturityDate === null) {
      LoanTermMonths = parseInt(moments((_j = layout.currentLoan) === null || _j === void 0 ? void 0 : _j.loanMaturityDate).diff(moments((_k = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _k === void 0 ? void 0 : _k.nextPaymentDueDate), 'months', true));
    } else {
      var EndTerm = this.state.targetMaturityDate;
      LoanTermMonths = parseInt(EndTerm.diff(moments((_l = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _l === void 0 ? void 0 : _l.nextPaymentDueDate), 'months', true));
    }
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        extraSmall: "(min-width: 0px) and (max-width: 569px)",
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Amortization Calculator"
      }), /*#__PURE__*/React.createElement(PnmacSectionListView, {
        openDefaults: [translations.howToUse, translations.AmortizationCalculatorMsg],
        ref: _this.expRef,
        data: dataExpandable,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
          var item = _a.item,
            index = _a.index;
          if (collapsed.some(function (s) {
            return s == item.header;
          })) {
            if (item.header == "".concat(translations.howToUse)) {
              return /*#__PURE__*/React.createElement("div", {
                style: __assign(__assign({}, styles.amortCalc.section), {
                  borderBottom: "1px solid #e9e9e9",
                  padding: 20
                })
              }, /*#__PURE__*/React.createElement(PnmacParagraph, {
                style: textStyle.formBody
              }, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations === null || translations === void 0 ? void 0 : translations.PurposeMsg
                }
              })));
            } else if (item.header == "".concat(translations.AmortizationCalculatorMsg)) {
              return /*#__PURE__*/React.createElement("div", {
                style: __assign(__assign({}, styles.amortCalc.section), {
                  borderBottomLeftRadius: 10,
                  borderBottomRightRadius: 10
                })
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: matches.small ? "column" : "row",
                  borderBottom: "1px solid #e9e9e9"
                }
              }, /*#__PURE__*/React.createElement(PnmacCard, {
                style: {
                  width: matches.small ? "auto" : 300,
                  height: 120,
                  padding: 20,
                  margin: 20,
                  backgroundColor: "#fbfbfb"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "row"
                }
              }, /*#__PURE__*/React.createElement("div", null, leftContent(require("../assets/refi-home.svg"), matches.small)), /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: 25,
                  alignSelf: "center",
                  width: "100%",
                  height: "100%",
                  justifyContent: "center"
                }
              }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                style: __assign(__assign({}, textStyle.formTitleSection), {
                  fontSize: matches.small ? 14 : 16,
                  marginRight: "10%",
                  marginBottom: 20
                })
              }, translations.ForLoanNumber), (_b = layout.currentLoan) === null || _b === void 0 ? void 0 : _b.loanId))), /*#__PURE__*/React.createElement("div", {
                style: {
                  paddingBottom: 20
                }
              }, /*#__PURE__*/React.createElement(PnmacCard, {
                style: {
                  width: matches.small ? "auto" : 450,
                  height: 120,
                  padding: 20,
                  margin: 20,
                  backgroundColor: "#fbfbfb"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  marginTop: 10
                }
              }, leftContent(require("../assets/calculator-plain.svg"), matches.small, true)), /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: 20
                }
              }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                style: __assign(__assign({}, textStyle.formTitleSection), {
                  fontSize: matches.small ? 14 : 16
                })
              }, translations.WhatIsYourGoal), /*#__PURE__*/React.createElement(View, {
                style: {
                  marginTop: 10
                }
              }, /*#__PURE__*/React.createElement(PnmacSelect, {
                accessibilityLabel: "Pick a goal to calculate",
                idTag2: "goal-picker",
                style: {
                  inputAndroid: {
                    width: "100%",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderWidth: 1,
                    borderColor: 'black',
                    borderRadius: 8,
                    color: 'black',
                    paddingRight: 30
                  }
                },
                value: tempGoal,
                onValueChange: function (value) {
                  return _this.setState({
                    goal: value,
                    targetMaturityDate: null,
                    amortzationData: null
                  });
                },
                items: [{
                  label: translations.LoanAmortizationCalculator,
                  value: 'LAC'
                }, {
                  label: translations.CurrentPrincipleAndInterest,
                  value: 'CPI'
                }, {
                  label: translations.PayoffBySpecificDate,
                  value: 'PSD'
                }, {
                  label: translations.MakeExtraPayments,
                  value: 'MEP'
                }] || [{
                  label: "default",
                  value: "default"
                }]
              }))))))), /*#__PURE__*/React.createElement("div", null, _this.state.goal ? /*#__PURE__*/React.createElement("div", null, !_this.state.amortzationData ? /*#__PURE__*/React.createElement(PrincipleAndIntrestFields, {
                updateState: function (data) {
                  return _this.setState({
                    PayFrequency: data
                  });
                },
                loading: _this.state.loading,
                sequence: sequence,
                postRequest: _this.requestAmoritization,
                upDateMaturity: function (date) {
                  return _this.setState({
                    targetMaturityDate: date
                  });
                },
                targetMaturityDate: _this.state.targetMaturityDate,
                payFrequency: _this.state.PayFrequency,
                maturity: _this.state.goal == "PSD",
                translations: translations,
                layout: layout,
                extraPayment: _this.state.goal == "MEP",
                goal: _this.state.goal,
                state: _this.state,
                LoanTermMonths: LoanTermMonths
              }) : null) : null), /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center"
                }
              }, _this.state.amortzationData ? /*#__PURE__*/React.createElement("div", {
                style: {
                  paddingLeft: 20,
                  paddingRight: matches.small ? 20 : 0,
                  marginBottom: 40,
                  width: "94%"
                }
              }, _this.state.goal == "LAC" || _this.state.goal == "CPI" ? /*#__PURE__*/React.createElement("div", {
                style: __assign({
                  marginBottom: 20,
                  marginTop: 20
                }, textStyle.formBody)
              }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.yourMonthlyPI
                }
              }), " ", currencyFormatter('en-US', 'currency', 'USD', (_c = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _c === void 0 ? void 0 : _c.monthlyPayment)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.yourloancanbepaidoffby
                }
              }), " ", moments((_e = (_d = _this.state.amortzationData) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.termEndDate).format("MMMM YYYY"), " "))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
                style: textStyle.defaultTextTitle
              }, translations.QuickFacts), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
                style: textStyle.defaultTextDescription
              }, translations.ForThisLoanScenario)), /*#__PURE__*/React.createElement("table", {
                className: "quick-facts"
              }, /*#__PURE__*/React.createElement("tbody", {
                style: textStyle.formBody
              }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, translations.Payments), /*#__PURE__*/React.createElement("td", {
                style: {
                  paddingLeft: 15
                }
              }, ((_g = (_f = _this.state.amortzationData) === null || _f === void 0 ? void 0 : _f.response) === null || _g === void 0 ? void 0 : _g.loanMonths) || 0)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.MonthlyPIPayment
                }
              }), /*#__PURE__*/React.createElement("td", {
                style: {
                  paddingLeft: 15
                }
              }, currencyFormatter('en-US', 'currency', 'USD', (_j = (_h = _this.state.amortzationData) === null || _h === void 0 ? void 0 : _h.response) === null || _j === void 0 ? void 0 : _j.monthlyPayment))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.TotalInterestPaid
                }
              }), /*#__PURE__*/React.createElement("td", {
                style: {
                  paddingLeft: 15
                }
              }, currencyFormatter('en-US', 'currency', 'USD', (_l = (_k = _this.state.amortzationData) === null || _k === void 0 ? void 0 : _k.response) === null || _l === void 0 ? void 0 : _l.totalInterest))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.PayoffDate
                }
              }), /*#__PURE__*/React.createElement("td", {
                style: {
                  paddingLeft: 15
                }
              }, moments((_o = (_m = _this.state.amortzationData) === null || _m === void 0 ? void 0 : _m.response) === null || _o === void 0 ? void 0 : _o.termEndDate).format("MM/DD/YYYY")))))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
                style: textStyle.formBody
              }, _this.state.goal == "PSD" ? /*#__PURE__*/React.createElement("div", {
                style: textStyle.formBody
              }, /*#__PURE__*/React.createElement("p", null, translations.WhenYouPayoffYourLoanByMsgPartOne, /*#__PURE__*/React.createElement("span", {
                className: "amortcalcdatefield"
              }, " ", moments(_this.state.targetMaturityDate).format("MM/DD/YYYY"))), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.YourNewMonthlyPaymentWillBeMsgPartOne
                }
              }), " ", currencyFormatter('en-US', 'currency', 'USD', (_p = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _p === void 0 ? void 0 : _p.monthlyPayment)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.YourInterestSavingsWillBeMsgPartOne
                }
              }), " ", currencyFormatter('en-US', 'currency', 'USD', Math.abs(((_q = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _q === void 0 ? void 0 : _q.totalInterest) - ((_r = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _r === void 0 ? void 0 : _r.currentInterest))), " ")), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, translations.QuickFacts), /*#__PURE__*/React.createElement("br", null), translations.OverTheRemainingLife), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", null, translations.Current)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", null, translations.New))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, translations.Payments), /*#__PURE__*/React.createElement("td", null, (_t = (_s = _this.state.amortzationData) === null || _s === void 0 ? void 0 : _s.response) === null || _t === void 0 ? void 0 : _t.currentLoanMonths), /*#__PURE__*/React.createElement("td", null, amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.amortizationSchedule.length)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, translations.MonthlyPayment), /*#__PURE__*/React.createElement("td", null, currencyFormatter('en-US', 'currency', 'USD', (_u = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _u === void 0 ? void 0 : _u.currentMonth)), /*#__PURE__*/React.createElement("td", null, currencyFormatter('en-US', 'currency', 'USD', (_v = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _v === void 0 ? void 0 : _v.monthlyPayment))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, translations.InterestPaid), /*#__PURE__*/React.createElement("td", null, currencyFormatter('en-US', 'currency', 'USD', (_w = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _w === void 0 ? void 0 : _w.totalInterest)), /*#__PURE__*/React.createElement("td", null, currencyFormatter('en-US', 'currency', 'USD', (_x = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _x === void 0 ? void 0 : _x.currentInterest))))))) : /*#__PURE__*/React.createElement("div", {
                style: textStyle.formBody
              }, /*#__PURE__*/React.createElement("p", null, translations.ByPayingDownPrincipalFaster), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.YourLoanPaidOffMsgPartOne
                }
              }), " ", parseInt(soonerYears), "  ", translations.YourLoanPaidOffMsgPartTwo, " ", soonerMonths, " ", translations.YourLoanPaidOffMsgPartThree, " "), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                dangerouslySetInnerHTML: {
                  __html: translations.YourInterestSavingsWillBeMsgPartOne
                }
              }), " ", currencyFormatter('en-US', 'currency', 'USD', Math.abs(((_y = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _y === void 0 ? void 0 : _y.totalInterest) - ((_z = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _z === void 0 ? void 0 : _z.currentInterest))), " ")), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, translations.QuickFacts), /*#__PURE__*/React.createElement("br", null), translations.OverTheRemainingLife), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", null, translations.Current)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", null, translations.New))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, translations.AdditionalPayments), /*#__PURE__*/React.createElement("td", null, "   -   "), /*#__PURE__*/React.createElement("td", null, currencyFormatter('en-US', 'currency', 'USD', (_0 = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _0 === void 0 ? void 0 : _0.additionalPayment))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, translations.InterestPaid), /*#__PURE__*/React.createElement("td", null, currencyFormatter('en-US', 'currency', 'USD', (_1 = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _1 === void 0 ? void 0 : _1.totalInterest)), /*#__PURE__*/React.createElement("td", null, currencyFormatter('en-US', 'currency', 'USD', (_2 = amortzationData === null || amortzationData === void 0 ? void 0 : amortzationData.response) === null || _2 === void 0 ? void 0 : _2.currentInterest))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, translations.PayoffDate), /*#__PURE__*/React.createElement("td", null, moments((_3 = layout.currentLoan) === null || _3 === void 0 ? void 0 : _3.loanMaturityDate).format("MMMM YYYY")), /*#__PURE__*/React.createElement("td", null, moments((_5 = (_4 = _this.state.amortzationData) === null || _4 === void 0 ? void 0 : _4.response) === null || _5 === void 0 ? void 0 : _5.termEndDate).format("MMMM YYYY"))))))))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
                style: {
                  width: matches.small ? "auto" : "initial"
                }
              }, /*#__PURE__*/React.createElement("div", {
                style: {
                  width: matches.small ? "auto" : "initial",
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }
              }, /*#__PURE__*/React.createElement(PnmacTabs, {
                selected: page,
                style: layout.mobile ? {
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  width: "70%",
                  paddingLeft: 10
                } : {
                  justifyContent: "flex-start",
                  marginLeft: 20,
                  marginTop: matches.small ? 20 : 0
                },
                iconStyle: __assign(__assign({}, styles.oneTimePayment.tabPan), textStyle.nonActiveTab),
                selectedIconStyle: __assign({
                  height: "auto",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10
                }, textStyle.activeTab),
                onSelect: function (el) {
                  return _this.setState({
                    page: el.props.name
                  });
                }
              }, /*#__PURE__*/React.createElement("div", {
                name: "changeValues"
              }, /*#__PURE__*/React.createElement(PnmacText, {
                style: page === "changeValues" ? textStyle.activeTabText : textStyle.nonActiveTabText
              }, "Change Values")), /*#__PURE__*/React.createElement("div", {
                name: "schedule"
              }, /*#__PURE__*/React.createElement(PnmacText, {
                style: page === "schedule" ? textStyle.activeTabText : textStyle.nonActiveTabText
              }, "Schedule")), /*#__PURE__*/React.createElement("div", {
                name: "chart"
              }, /*#__PURE__*/React.createElement(PnmacText, {
                style: page === "chart" ? textStyle.activeTabText : textStyle.nonActiveTabText
              }, "Chart"))), page === "schedule" && (/*#__PURE__*/React.createElement("div", {
                style: __assign(__assign({
                  marginRight: '100px'
                }, matches.small && page === "schedule" && {
                  position: 'fixed',
                  marginTop: '20px',
                  marginLeft: '300px'
                }), matches.extraSmall && page === "schedule" && {
                  position: 'fixed',
                  marginLeft: '163px',
                  marginTop: '-70px'
                })
              }, /*#__PURE__*/React.createElement(PnmacUIButton, {
                idTag1: 'btnDownload',
                mode: "contained",
                onClick: handlePDFExport
              }, "Download"))))), /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  width: matches.small ? "auto" : "94%",
                  border: "1px solid #DDD",
                  borderRadius: 10,
                  backgroundColor: "#fbfbfb"
                }
              }, page === "chart" ? /*#__PURE__*/React.createElement("div", {
                style: {
                  width: "100%"
                }
              }, /*#__PURE__*/React.createElement(Line, {
                data: function () {
                  return _this.getSummaryLineChartData(_this.state.amortzationData);
                },
                backgroundColor: "#FFF"
              })) : page === "schedule" ? /*#__PURE__*/React.createElement("div", {
                style: {
                  width: "100%"
                }
              }, /*#__PURE__*/React.createElement(PnmacTable, {
                borderStyle: {
                  borderColor: 'transparent'
                }
              }, /*#__PURE__*/React.createElement(PnmacRow, {
                flexArr: [1, 1, 1, 1, 1],
                data: tableHead,
                style: __assign(__assign({}, styles.tables.head), {
                  height: matches.small ? 80 : 40
                }),
                textStyle: __assign(__assign({}, styles.tables.textHead), textStyle.defaultTextTitle)
              }), (_6 = tableData === null || tableData === void 0 ? void 0 : tableData.slice((pagination - 1) * 10, (pagination - 1) * 10 + 10)) === null || _6 === void 0 ? void 0 : _6.map(function (rowData, index) {
                return /*#__PURE__*/React.createElement(PnmacRow, {
                  key: index,
                  flexArr: [1, 1, 1, 1, 1],
                  data: rowData,
                  textStyle: [styles.tables.text, textStyle.defaultTextDescription]
                });
              })), /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex",
                  justifyContent: "center"
                }
              }, /*#__PURE__*/React.createElement(Pagination, {
                style: {
                  marginTop: 20
                },
                onChange: function (event, page) {
                  return _this.setState({
                    pagination: page
                  });
                },
                page: pagination,
                defaultPage: 1,
                count: Math.floor(parseInt((tableData === null || tableData === void 0 ? void 0 : tableData.length) / 10)) + 1,
                size: matches.small ? "small" : "medium",
                variant: "outlined",
                shape: "rounded",
                color: "primary"
              })), /*#__PURE__*/React.createElement("div", {
                style: {
                  marginTop: 40
                }
              }, /*#__PURE__*/React.createElement("span", {
                className: 'htmlToNative',
                style: textStyle.defaultTextDescription,
                dangerouslySetInnerHTML: {
                  __html: translations === null || translations === void 0 ? void 0 : translations.PrincipcalInterestMsg
                }
              }))) : /*#__PURE__*/React.createElement("div", {
                style: {
                  display: "flex"
                }
              }, /*#__PURE__*/React.createElement(PrincipleAndIntrestFields, {
                updateState: function (data) {
                  return _this.setState({
                    PayFrequency: data
                  });
                },
                loading: _this.state.loading,
                sequence: sequence,
                postRequest: _this.requestAmoritization,
                upDateMaturity: function (date) {
                  return _this.setState({
                    targetMaturityDate: date
                  });
                },
                targetMaturityDate: _this.state.targetMaturityDate,
                payFrequency: _this.state.PayFrequency,
                updatePayFrequency: function (freq) {
                  return _this.setState({
                    PayFrequency: freq
                  });
                },
                maturity: _this.state.goal == "PSD",
                translations: translations,
                layout: layout,
                extraPayment: _this.state.goal == "MEP",
                goal: _this.state.goal,
                state: _this.state,
                LoanTermMonths: LoanTermMonths
              })))) : null));
            }
          } else {
            return /*#__PURE__*/React.createElement("div", null);
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c, _d, _e;
          var title = _a.section.title;
          var last = title === "".concat(translations.AmortizationCalculatorMsg);
          var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
          return /*#__PURE__*/React.createElement(PnmacRowHeader, {
            rowHeaderStyles: textStyle.formTitleSection,
            rowHeaderContainerStyles: {
              backgroundColor: "#FFF",
              marginLeft: 10,
              marginRight: 10,
              borderBottomLeftRadius: last && !open ? 10 : 0,
              borderBottomRightRadius: last && !open ? 10 : 0,
              borderTopLeftRadius: last ? 0 : 10,
              borderTopRightRadius: last ? 0 : 10,
              borderBottom: last && !open ? "none" : "1px solid #e9e9e9",
              marginTop: 0
            },
            onClickExpand: function () {
              var _a;
              return (_a = _this.expRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacToolTip, {
              title: "Expand " + title
            }, /*#__PURE__*/React.createElement("div", {
              style: __assign({
                alignSelf: "center"
              }, textStyle.formTitleSection)
            }, title)),
            isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
          });
        }
      }));
    });
  };
  return AmortizationCalculator;
}(Component);
var PrincipleAndIntrestFields = function (_a) {
  var _b, _c, _d;
  var goal = _a.goal,
    translations = _a.translations,
    layout = _a.layout,
    maturity = _a.maturity,
    targetMaturityDate = _a.targetMaturityDate,
    upDateMaturity = _a.upDateMaturity,
    postRequest = _a.postRequest,
    loading = _a.loading,
    state = _a.state,
    extraPayment = _a.extraPayment,
    updateState = _a.updateState,
    sequence = _a.sequence,
    LoanTermMonths = _a.LoanTermMonths,
    payFrequency = _a.payFrequency;
  var _e = React.useState(""),
    lacPrincipBalance = _e[0],
    setLacPrincipBalance = _e[1];
  var _f = React.useState(""),
    lacInterestRate = _f[0],
    setLacInterestRate = _f[1];
  var _g = React.useState(null),
    lacStartDate = _g[0],
    setLacStartDate = _g[1];
  var _h = React.useState(null),
    lacMaturityDate = _h[0],
    setLacMaturityDate = _h[1];
  var _j = React.useState(""),
    paymentAmount = _j[0],
    setPaymentAmount = _j[1];
  var _k = React.useState((_b = layout.currentLoan) === null || _b === void 0 ? void 0 : _b.nextPaymentDueDate),
    beginDate = _k[0],
    setBeginDate = _k[1];
  var _l = React.useState(null),
    endDate = _l[0],
    setEndDate = _l[1];
  var _m = React.useState(null),
    exceedBalanceError = _m[0],
    setExceedBalanceError = _m[1];
  var _o = React.useState(false),
    beginDateError = _o[0],
    setBeginDateError = _o[1];
  var _p = React.useState(false),
    endDateError = _p[0],
    setEndDateError = _p[1];
  var clearFields = function () {
    setLacPrincipBalance('');
    setLacInterestRate('');
    setLacStartDate(null);
    setLacMaturityDate(null);
    setPaymentAmount('');
    setBeginDate(null);
    setEndDate(null);
    upDateMaturity(null);
    updateState("default");
  };
  var curtailmentStart = (_c = sequence === null || sequence === void 0 ? void 0 : sequence.find(function (s) {
    return s.date === moments(beginDate).format("MM/YYYY");
  })) === null || _c === void 0 ? void 0 : _c.curtailment;
  var curtailmentEnd = (_d = sequence === null || sequence === void 0 ? void 0 : sequence.find(function (s) {
    return s.date === moments(endDate).format("MM/YYYY");
  })) === null || _d === void 0 ? void 0 : _d.curtailment;
  var lacDisableContinue = lacPrincipBalance === "" || lacInterestRate === "" || lacStartDate === null || lacMaturityDate === null;
  var maturityDisableContinue = targetMaturityDate === null;
  var extraPaymentDisableContinue = payFrequency === null || paymentAmount === "" || beginDate === null || endDate === null;
  function renderSwitch(goal) {
    switch (goal) {
      case "LAC":
        return lacDisableContinue;
        break;
      case "CPI":
        return false;
        break;
      case "PSD":
        return maturityDisableContinue;
        break;
      case "MEP":
        return extraPaymentDisableContinue;
        break;
      default:
        return false;
    }
  }
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    queries: {
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }
  }, function (matches) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        padding: 20,
        margin: 20,
        backgroundColor: "#fbfbfb"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        borderBottom: "1px solid #efefef"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: extraPayment ? matches.small ? "column" : "row" : "column",
        justifyContent: extraPayment ? "space-between" : "initial",
        width: extraPayment || matches.small ? "100%" : 500,
        paddingLeft: matches.small ? 0 : 40,
        paddingTop: 10,
        paddingBottom: 10
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: extraPayment ? matches.small ? "100%" : "45%" : "auto"
      }
    }, goal === "LAC" ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        width: extraPayment ? "48%" : "auto"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.CurrentPrincipalBalanceACVM)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacTextInput, {
      key: 1,
      mode: "outlined",
      style: __assign({
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        height: 35
      }, textStyle.defaultTextDescription),
      placeholder: "$0",
      value: "$".concat(lacPrincipBalance),
      onChangeText: function (data) {
        currencyFormatter('en-US', 'currency', 'USD', setLacPrincipBalance(data.replace("$", "")));
      }
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.InterestRateACVM)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacTextInput, {
      key: 2,
      mode: "outlined",
      placeholder: "0.000%",
      style: __assign({
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        height: 35
      }, textStyle.defaultTextDescription),
      value: "".concat(lacInterestRate, "%"),
      onChangeText: function (data) {
        setLacInterestRate(data.replace("%", ""));
      }
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.StartDateACVM)), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "70%" : "37%",
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: MomentAdapter
    }, /*#__PURE__*/React.createElement(DatePicker, {
      disablePast: true,
      renderInput: function (props) {
        return /*#__PURE__*/React.createElement(TextField, __assign({}, props));
      },
      value: lacStartDate,
      onChange: function (date) {
        return setLacStartDate(date);
      },
      animateYearScrolling: true
    })))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.MaturityDateACVM)), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "70%" : "37%",
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: MomentAdapter
    }, /*#__PURE__*/React.createElement(DatePicker, {
      disablePast: true,
      renderInput: function (props) {
        return /*#__PURE__*/React.createElement(TextField, __assign({}, props));
      },
      value: lacMaturityDate,
      onChange: function (date) {
        return setLacMaturityDate(date);
      },
      animateYearScrolling: true
    }))))) : /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.CurrentPrincipalBalanceACVM)), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      key: 5,
      mode: "outlined",
      style: __assign({
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        height: 35
      }, textStyle.defaultTextDescription),
      placeholder: "$0",
      value: currencyFormatter('en-US', 'currency', 'USD', (_b = (_a = layout.currentLoan) === null || _a === void 0 ? void 0 : _a.balanceSummary) === null || _b === void 0 ? void 0 : _b.unpaidPrincipalBalanceAmount),
      disabled: goal === "CPI" || goal === "PSD" || goal === "MEP"
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.InterestRateACVM)), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      key: 6,
      mode: "outlined",
      placeholder: "0.00%",
      style: __assign({
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        height: 35
      }, textStyle.defaultTextDescription),
      value: percentFormatter('en-US', 'percent', (_c = layout.currentLoan) === null || _c === void 0 ? void 0 : _c.currentInterestRate),
      disabled: goal === "CPI" || goal === "PSD" || goal === "MEP"
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.StartDateACVM)), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      key: 7,
      mode: "outlined",
      placeholder: "MM/DD/YYYY",
      style: __assign({
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        height: 35
      }, textStyle.defaultTextDescription),
      value: moments((_d = layout.currentLoan) === null || _d === void 0 ? void 0 : _d.nextPaymentDueDate).format("MM/DD/YYYY"),
      disabled: goal === "CPI" || goal === "PSD" || goal === "MEP"
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.MaturityDateACVM)), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      key: 8,
      mode: "outlined",
      placeholder: "MM/DD/YYYY",
      style: __assign({
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        height: 35
      }, textStyle.defaultTextDescription),
      value: moments((_e = layout.currentLoan) === null || _e === void 0 ? void 0 : _e.loanMaturityDate).format("MM/DD/YYYY"),
      disabled: goal === "CPI" || goal === "PSD" || goal === "MEP"
    }))))), maturity ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, translations.TargetMaturityDateACVM)), /*#__PURE__*/React.createElement("div", {
      style: {
        width: "37%",
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: MomentAdapter
    }, /*#__PURE__*/React.createElement(DatePicker, {
      disablePast: true,
      renderInput: function (props) {
        return /*#__PURE__*/React.createElement(TextField, __assign({}, props));
      },
      value: targetMaturityDate,
      onChange: function (date) {
        return upDateMaturity(date);
      },
      animateYearScrolling: true
    })))), /*#__PURE__*/React.createElement("div", {
      style: {
        alignSelf: "center",
        marginTop: 45
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, "Loan Term: "), /*#__PURE__*/React.createElement(PnmacText, null, LoanTermMonths, " months"))) : null, extraPayment ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        width: extraPayment ? matches.small ? "100%" : "45%" : "auto",
        marginTop: matches.small ? 10 : 0,
        marginRight: 50
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: matches.small ? 10 : 0,
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, "Payment Frequency")), /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: matches.small ? 10 : 0,
        width: matches.small ? "initial" : "43%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSelect, {
      style: {
        fontSize: 16,
        borderRadius: 10,
        paddingRight: 30
      },
      value: state === null || state === void 0 ? void 0 : state.PayFrequency,
      onValueChange: function (value) {
        return updateState(value);
      },
      items: [{
        label: 'Single Lump Sum',
        value: '1'
      }, {
        label: 'Monthly',
        value: '2'
      }, {
        label: 'Quarterly',
        value: '3'
      }, {
        label: 'Semi-Annually',
        value: '6'
      }, {
        label: 'Annually',
        value: '12'
      }] || [{
        label: "default",
        value: "default"
      }]
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, "Payment Amount")), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "43%"
      }
    }, /*#__PURE__*/React.createElement(PnmacTextInput, {
      mode: "outlined",
      error: exceedBalanceError,
      placeholder: "$0",
      style: __assign({
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        height: 35
      }, textStyle.defaultTextDescription),
      value: "$".concat(paymentAmount),
      onChangeText: function (data) {
        if (checkForAllNumbers(data.replace("$", ""))) {
          setPaymentAmount(data.replace("$", ""));
        }
      },
      onBlur: function () {
        var _a, _b;
        if (paymentAmount > ((_b = (_a = layout.currentLoan) === null || _a === void 0 ? void 0 : _a.balanceSummary) === null || _b === void 0 ? void 0 : _b.unpaidPrincipalBalanceAmount)) {
          setExceedBalanceError(true);
        } else setExceedBalanceError(false);
      }
    }), exceedBalanceError ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacText, {
      style: {
        fontSize: 12,
        color: "#b33734"
      }
    }, "Amount cannot exceed the Current Principal Balance.")) : null))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, console.log('begin date: ', (_f = layout.currentLoan) === null || _f === void 0 ? void 0 : _f.nextPaymentDueDate), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, "Begin Date")), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "auto" : "37%",
        marginTop: 10,
        marginBottom: matches.small ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: MomentAdapter
    }, /*#__PURE__*/React.createElement(DatePicker, {
      disablePast: true,
      minDate: (_g = layout.currentLoan) === null || _g === void 0 ? void 0 : _g.nextPaymentDueDate,
      renderInput: function (props) {
        return /*#__PURE__*/React.createElement(TextField, __assign({}, props));
      },
      value: beginDate,
      onChange: function (date) {
        return setBeginDate(date);
      },
      autoOk: true,
      disableEnforceFocus: true,
      animateYearScrolling: true,
      onBlur: function () {
        if (!beginDate) {
          setBeginDateError(true);
        } else {
          setBeginDateError(false);
        }
      }
    })), beginDateError && /*#__PURE__*/React.createElement(PnmacText, {
      style: {
        color: "#B33734"
      }
    }, "Please enter a valid begin date"))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "initial" : "50%"
      }
    }, /*#__PURE__*/React.createElement(PnmacSubheading, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 14 : 16
      })
    }, "End Date")), /*#__PURE__*/React.createElement("div", {
      style: {
        width: matches.small ? "auto" : "37%",
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: MomentAdapter
    }, /*#__PURE__*/React.createElement(DatePicker, {
      disablePast: true,
      renderInput: function (props) {
        return /*#__PURE__*/React.createElement(TextField, __assign({}, props));
      },
      value: endDate,
      onChange: function (date) {
        return setEndDate(date);
      },
      animateYearScrolling: true,
      maxDate: moments((_h = layout.currentLoan) === null || _h === void 0 ? void 0 : _h.loanMaturityDate).format("MM/DD/YYYY"),
      onBlur: function () {
        if (!endDate) {
          setEndDateError(true);
        } else {
          setEndDateError(false);
        }
      }
    })), endDateError && /*#__PURE__*/React.createElement(PnmacText, {
      style: {
        color: "#B33734"
      }
    }, "Please enter a valid end date")))) : null)), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        justifyContent: "space-between",
        margin: 20
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        alignSelf: "center",
        width: matches.small ? "100%" : "auto"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: "outlined",
      iconSize: 30,
      iconStyles: {
        marginLeft: 10
      },
      style: {
        margin: 10
      },
      disabled: goal === "CPI",
      onPress: function () {
        clearFields();
      }
    }, "Clear Values")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      disabled: renderSwitch(goal),
      mode: "contained",
      iconSize: 30,
      iconStyles: {
        marginLeft: 10
      },
      style: {
        margin: 10
      },
      loading: loading,
      onPress: function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        postRequest({
          operation: "simpleFixed",
          requestType: "monthlyPayment",
          termMonths: targetMaturityDate ? loanTerm(new Date((_a = layout.currentLoan) === null || _a === void 0 ? void 0 : _a.nextPaymentDueDate), new Date(targetMaturityDate)) : 0,
          NewTermmonths: parseInt(moments((_b = layout.currentLoan) === null || _b === void 0 ? void 0 : _b.loanMaturityDate).diff(moments((_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.nextPaymentDueDate), 'months', true)),
          amortization: true,
          loanPrincipal: lacPrincipBalance || ((_e = (_d = layout.currentLoan) === null || _d === void 0 ? void 0 : _d.balanceSummary) === null || _e === void 0 ? void 0 : _e.unpaidPrincipalBalanceAmount),
          loanInterest: lacInterestRate ? parseFloat(lacInterestRate).toFixed(3) : parseFloat(((_f = layout.currentLoan) === null || _f === void 0 ? void 0 : _f.currentInterestRate) * 100).toFixed(3),
          amortizationStartDate: (_g = layout.currentLoan) === null || _g === void 0 ? void 0 : _g.nextPaymentDueDate,
          // This is the Maturity Date / Target Maturity Date field in Payoff by a Specified Date. Runs addAmortMonths taking in the current month, and second param says if a targetMaturityDate exists (the datePicker component), then calculate end date using the datePicker. If not, use the current data inside Maturity Date.
          amortizationEndDate: addMonths(new Date((_h = layout.currentLoan) === null || _h === void 0 ? void 0 : _h.nextPaymentDueDate), targetMaturityDate ? loanTerm(new Date((_j = layout.currentLoan) === null || _j === void 0 ? void 0 : _j.nextPaymentDueDate), new Date(targetMaturityDate)) : loanTerm(new Date((_k = layout.currentLoan) === null || _k === void 0 ? void 0 : _k.nextPaymentDueDate), new Date((_l = layout.currentLoan) === null || _l === void 0 ? void 0 : _l.loanMaturityDate))),
          monthlyPaymentAmount: (_m = layout.currentLoan) === null || _m === void 0 ? void 0 : _m.monthlyPaymentAmount,
          // monthlyPaymentAmount: 0,
          termStartDate: lacStartDate || ((_o = layout.currentLoan) === null || _o === void 0 ? void 0 : _o.nextPaymentDueDate),
          termEndDate: addMonths(new Date((_p = layout.currentLoan) === null || _p === void 0 ? void 0 : _p.nextPaymentDueDate), targetMaturityDate ? loanTerm(new Date((_q = layout.currentLoan) === null || _q === void 0 ? void 0 : _q.nextPaymentDueDate), new Date(targetMaturityDate)) : loanTerm(new Date((_r = layout.currentLoan) === null || _r === void 0 ? void 0 : _r.nextPaymentDueDate), new Date(lacMaturityDate || ((_s = layout.currentLoan) === null || _s === void 0 ? void 0 : _s.loanMaturityDate)))),
          GoalName: goal,
          CurrentLoanEndDate: moments((_t = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _t === void 0 ? void 0 : _t.loanMaturityDate),
          listScheduledCurtailments: [{
            startMonth: curtailmentStart,
            endMonth: curtailmentEnd,
            extraAmount: paymentAmount,
            extraIntervalMonths: state === null || state === void 0 ? void 0 : state.PayFrequency
          }],
          listCurtailmentData: sequence
        });
      }
    }, translations.Calculate)))));
  });
};
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(AmortizationCalculator, function (props) {
  return props.translations.AmortizationCalculatorMsg;
}));